module.exports = ".example-pizza-party {\n  color: hotpink;\n}\n"